import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Modal, Spinner } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiChevronRight, mdiTrashCanOutline } from "@mdi/js";

import { QuestionnaireResponseEntity } from "../../entities/QuestionnaireResponseEntity";

import ListCard from "../ListCard";

type AvaliacaoCardPropsContent = {
	data: QuestionnaireResponseEntity;
	skeleton?: never;
};

type AvaliacaoCardPropsSkeleton = {
	data?: never;
	onClick?: never;
	onRemove?: never;
	skeleton: true;
};

type AvaliacaoCardProps = AvaliacaoCardPropsContent | AvaliacaoCardPropsSkeleton;

export default function AvaliacaoCard(props: AvaliacaoCardProps) {
	const navigate = useNavigate();

	const [removeModal, setRemoveModal] = useState(false);
	const [removeLoadingModal, setRemoveLoadingModal] = useState(false);
	const [removed, setRemoved] = useState(false);

	function handleClick() {
		if (!props.skeleton && props.data) {
			navigate("/edificacaoFormulario/" + props.data.id);
		}
	}

	function handleClickRemove(e: any) {
		e.preventDefault();
		e.stopPropagation();
		setRemoveLoadingModal(true);
		setRemoveModal(true);
	}

	async function handleRemove() {
		setRemoved(true);
	}

	function handleCloseModal() {
		if (!removeLoadingModal) {
			setRemoveModal(false);
		}
	}

	let skeletonButton = "";
	if (props.skeleton) {
		skeletonButton = "skeleton skeleton-button";
	}

	if (removed) {
		return <></>;
	}

	return (
		<>
			<ListCard onClick={handleClick}>
				<ListCard.Content>
					<ListCard.Item auto>
						<ListCard.Title skeleton={props.skeleton}>Identificação</ListCard.Title>
						<ListCard.Text skeleton={props.skeleton}>#{props.data?.id ?? "..."}</ListCard.Text>
					</ListCard.Item>
					<ListCard.Item>
						<ListCard.Title skeleton={props.skeleton}>Edificação</ListCard.Title>
						<ListCard.Text skeleton={props.skeleton}>{props.data?.questionnaireName ?? "..."}</ListCard.Text>
					</ListCard.Item>
					<ListCard.Item>
						<ListCard.Title skeleton={props.skeleton}>Usuário</ListCard.Title>
						<ListCard.Text skeleton={props.skeleton}>{props.data?.person?.name ?? "..."}</ListCard.Text>
					</ListCard.Item>
					<ListCard.Item auto>
						<ListCard.Title skeleton={props.skeleton}>Data</ListCard.Title>
						<ListCard.Text skeleton={props.skeleton}>{props.data?.responseDate ?? "..."}</ListCard.Text>
					</ListCard.Item>
				</ListCard.Content>
				<ListCard.Action>
					<Button variant="light" className={`me-2 ${skeletonButton}`} onClick={handleClickRemove}>
						<Icon path={mdiTrashCanOutline} size={1} className="text-danger" />
					</Button>
					<Icon path={mdiChevronRight} size={1} className={`text-muted m-2 ${skeletonButton}`} />
				</ListCard.Action>
			</ListCard>

			<Modal show={removeModal} onHide={handleCloseModal} centered>
				<Modal.Header closeButton>
					<Modal.Title>Remover Edificação</Modal.Title>
				</Modal.Header>
				<Modal.Body className="text-center">{!removeLoadingModal ? "Deseja realmente remover esta edificação?" : <Spinner />}</Modal.Body>
				{!removeLoadingModal && (
					<Modal.Footer>
						<Button variant="secondary" onClick={handleCloseModal}>
							Cancelar
						</Button>
						<Button variant="danger" onClick={handleRemove}>
							Remover
						</Button>
					</Modal.Footer>
				)}
			</Modal>
		</>
	);
}
